import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { push } from "react-router-redux";
import {
  Field,
  FieldArray,
  reduxForm,
  SubmissionError,
  change,
  formValueSelector,
} from "redux-form";
import { fetchCustomers } from "../actions/customers";
import ErrorMessage from "../components/ErrorMessage";
import LoadingProgress from "../components/LoadingProgress";

import Box from "../components/Box";
import { fetchQR, updateQR } from "../actions/qrs";
import {
  renderInputField,
  renderTextAreaField,
  renderSelectField,
  renderColorField,
} from "../utils/forms";
import QRZonesList from "../components/QRZonesList";
import HeaderPreview from "../components/HeaderPreview";
import DesktopPreview from "../components/DesktopPreview";
import SmartphonePreview from "../components/SmartphonePreview";

class QREditForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false,
      customerSelected: "",
      showDynamicField: false,
    };

    this.submit = this.submit.bind(this);
  }

  componentDidMount() {
    const { fetchQR, fetchCustomers, match } = this.props;

    fetchQR(match.params.id);
    fetchCustomers();

    this.load(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.load(nextProps);
  }

  load(props) {
    const { qr, customers } = props;

    if (!this.state.loaded && qr && customers) {
      this.setState({
        loaded: true,
      });
    }
  }

  submit(props) {
    const { updateQR, qr } = this.props;

    return updateQR(qr._id, props).then((response) => {
      if (response.error) {
        throw new SubmissionError({
          _error: response.error.message,
          ...response.error.fields,
        });
      }

      return response;
    });
  }

  handleShowDynamicField() {
    this.setState({
      showDynamicField: true,
    });
  }

  handleFileUpload(e) {
    const file = e.target.files[0];
    if (file) {
      // Validate file size (2MB max)
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      if (file.size > maxSize) {
        alert("El archivo es demasiado grande. El tamaño máximo es 2MB.");
        e.target.value = ""; // Clear the input
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        const img = new Image();
        img.onload = () => {
          // Create canvas to compress image
          const canvas = document.createElement('canvas');
          const ctx = canvas.getContext('2d');
          
          // Set max dimensions to reduce size
          const maxWidth = 300;
          const maxHeight = 300;
          let width = img.width;
          let height = img.height;

          // Calculate new dimensions maintaining aspect ratio
          if (width > height) {
            if (width > maxWidth) {
              height = (height * maxWidth) / width;
              width = maxWidth;
            }
          } else {
            if (height > maxHeight) {
              width = (width * maxHeight) / height;
              height = maxHeight;
            }
          }

          canvas.width = width;
          canvas.height = height;
          
          // Clear canvas with transparency
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          // Try PNG first (for transparency), then JPEG if too large
          let compressedDataUrl = canvas.toDataURL('image/png');
          
          // If PNG is too large, try JPEG with white background
          if (compressedDataUrl.length > 40000) {
            // Try JPEG with different quality levels
            let quality = 0.8;
            
            // Fill white background for JPEG
            ctx.globalCompositeOperation = 'destination-over';
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, width, height);
            
            compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
            
            // Reduce quality if still too large
            while (compressedDataUrl.length > 40000 && quality > 0.3) {
              quality -= 0.1;
              compressedDataUrl = canvas.toDataURL('image/jpeg', quality);
            }
          }

          if (compressedDataUrl.length > 50000) {
            alert("La imagen es demasiado grande incluso después de la compresión. Por favor, use una imagen más pequeña o simple.");
            e.target.value = "";
            return;
          }

          this.props.dispatch(
            change("QREditForm", "headerConfig.logoBase64", compressedDataUrl)
          );
        };
        img.onerror = () => {
          alert("Error al cargar la imagen. Por favor, intente con otra imagen.");
          e.target.value = "";
        };
        img.src = reader.result;
      };
      reader.readAsDataURL(file);
    }
  }

  render() {
    const {
      customers,
      error,
      pristine,
      submitting,
      handleSubmit,
      primaryColor,
      secondaryColor,
      backgroundColor,
      textPrimary,
      textSecondary,
      logoBase64,
      backgroundImage,
      backgroundSmartphoneImage,
    } = this.props;
    const { showDynamicField, loaded } = this.state;

    if (!loaded) {
      return <LoadingProgress />
    }

    if (!customers) {
      return <LoadingProgress />
    }

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        <h1>
          <span className="text-vw-dark">EDITAR </span>
          <span className="text-vw-light">QR</span>
        </h1>
        <hr className="bg-vw-light" />

        <div className="row">
          <div className="col col-12 col-xs-12 col-md-2">
            <Box title="Configuración Básica" icon="cubes">
              <Field name="Type" component={renderSelectField} label="Tipo">
                <option value="">Selecciona un tipo...</option>
                <option value="pay">Pago</option>
                <option value="free">Gratis</option>
                <option value="test">Test</option>
              </Field>
              <Field name="Mode" component={renderSelectField} label="Modo">
                <option value="">Selecciona un modo...</option>
                <option value="0">MTO DIARIO</option>
                <option value="4">RESERVA ANTICIPADA</option>
                <option value="1">OTO DIARIO SIN PIN</option>
                <option value="3">OTO DIARIO CON PIN</option>
                <option value="2">BAQUEIRA</option>
              </Field>
            </Box>
          </div>

          <div className="col col-12 col-xs-12 col-md-2">
            <Box title="Colores del Header" icon="paint-brush">
              <Field
                name="headerConfig.primaryColor"
                component={renderColorField}
                label="Color Primario (Inicio Gradiente)"
              />
              <Field
                name="headerConfig.secondaryColor"
                component={renderColorField}
                label="Color Secundario (Fin Gradiente)"
              />
            </Box>
          </div>

          <div className="col col-12 col-xs-12 col-md-2">
            <Box title="Colores varios" icon="paint-brush">
              <Field
                name="headerConfig.backgroundColor"
                component={renderColorField}
                label="Color de Fondo"
              />
              <Field
                name="headerConfig.textPrimary"
                component={renderColorField}
                label="Texto Primario"
              />
              <Field
                name="headerConfig.textSecondary"
                component={renderColorField}
                label="Texto Secundario"
              />
            </Box>
          </div>

          <div className="col col-12 col-xs-12 col-md-3">
            <Box title="Logo" icon="image">
              <div className="form-group">
                <input
                  type="file"
                  className="form-control"
                  accept="image/*"
                  onChange={(e) => this.handleFileUpload(e)}
                />
                <small className="form-text text-muted">
                  Selecciona una imagen (máx. 2MB)
                </small>
              </div>
              {logoBase64 && (
                <div className="mt-2">
                  <label>Logo Actual:</label>
                  <div
                    className="text-center p-2"
                    style={{
                      backgroundColor: primaryColor,
                      borderRadius: "4px",
                    }}
                  >
                    <img
                      src={logoBase64}
                      alt="Logo Actual"
                      style={{ maxHeight: "80px", maxWidth: "100%" }}
                    />
                  </div>
                </div>
              )}
            </Box>
          </div>

          <div className="col col-12 col-xs-12 col-md-3">
            <Box title="Imágenes de fondo" icon="image">
              <Field
                name="headerConfig.backgroundImage"
                component={renderInputField}
                label="URL de Imagen de Fondo Desktop"
                placeholder="https://ejemplo.com/imagen-desktop.jpg"
              />
              <Field
                name="headerConfig.backgroundSmartphoneImage"
                component={renderInputField}
                label="URL de Imagen de Fondo Smartphone"
                placeholder="https://ejemplo.com/imagen-smartphone.jpg"
              />
            </Box>
          </div>
        </div>
        {/* Header Preview */}
        {/* <div className="row mt-3">
          <div className="col-12">
            <Box title="Vista Previa del Header" icon="eye">
              <HeaderPreview
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                backgroundColor={backgroundColor}
                textPrimary={textPrimary}
                textSecondary={textSecondary}
                logoBase64={logoBase64}
              />
            </Box>
          </div>
        </div> */}

        {/* Desktop and Smartphone Previews */}
        <div className="row mt-3">
          <div className="col-12 col-lg-6 mb-3 mb-lg-0">
            <Box title="Vista Previa Desktop" icon="desktop">
              <DesktopPreview
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                backgroundColor={backgroundColor}
                textPrimary={textPrimary}
                textSecondary={textSecondary}
                logoBase64={logoBase64}
                backgroundImage={backgroundImage}
              />
            </Box>
          </div>
          <div className="col-12 col-lg-6">
            <Box title="Vista Previa Smartphone" icon="mobile">
              <SmartphonePreview
                primaryColor={primaryColor}
                secondaryColor={secondaryColor}
                backgroundColor={backgroundColor}
                textPrimary={textPrimary}
                textSecondary={textSecondary}
                logoBase64={logoBase64}
                backgroundSmartphoneImage={backgroundSmartphoneImage}
                backgroundImage={backgroundImage}
              />
            </Box>
          </div>
        </div>

        {error && <div className="alert alert-danger">{error}</div>}
        <button
          className="btn bg-vw-light text-white mr-1 save"
          type="submit"
          disabled={pristine || submitting}
        >
          Guardar
        </button>
      </form>
    );
  }
}

QREditForm = reduxForm({
  form: "QREditForm",
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/qrs/${result.response._id}`);
  },
})(QREditForm);

const selector = formValueSelector("QREditForm");

const mapStateToProps = (state) => {
  const qr = state.qrs.qr;

  return {
    qr: qr,
    customers: state.customers.customers,
    initialValues: qr,
    primaryColor:
      selector(state, "headerConfig.primaryColor") ||
      (qr && qr.headerConfig && qr.headerConfig.primaryColor) ||
      "#01315f",
    secondaryColor:
      selector(state, "headerConfig.secondaryColor") ||
      (qr && qr.headerConfig && qr.headerConfig.secondaryColor) ||
      "#067ddb",
    backgroundColor:
      selector(state, "headerConfig.backgroundColor") ||
      (qr && qr.headerConfig && qr.headerConfig.backgroundColor) ||
      "#f3f3f3",
    textPrimary:
      selector(state, "headerConfig.textPrimary") ||
      (qr && qr.headerConfig && qr.headerConfig.textPrimary) ||
      "#01315f",
    textSecondary:
      selector(state, "headerConfig.textSecondary") ||
      (qr && qr.headerConfig && qr.headerConfig.textSecondary) ||
      "#808080",
    logoBase64:
      selector(state, "headerConfig.logoBase64") ||
      (qr && qr.headerConfig && qr.headerConfig.logoBase64),
    backgroundImage:
      selector(state, "headerConfig.backgroundImage") ||
      (qr && qr.headerConfig && qr.headerConfig.backgroundImage),
    backgroundSmartphoneImage:
      selector(state, "headerConfig.backgroundSmartphoneImage") ||
      (qr && qr.headerConfig && qr.headerConfig.backgroundSmartphoneImage),
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchQR: bindActionCreators(fetchQR, dispatch),
  updateQR: bindActionCreators(updateQR, dispatch),
  fetchCustomers: bindActionCreators(fetchCustomers, dispatch),
  push: bindActionCreators(push, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(QREditForm);
